<div class="dynamicGraph" [id]="advanceScatterId">
    <div [chart]="advanceScatteroptions" *ngIf="data"></div>
</div>
